// extracted by mini-css-extract-plugin
export default {"wrapper":"NR","dropdownButton":"OR","carat":"PR","caratPointingDown":"QR","selectBox":"RR","dropdown":"SR","header":"TR","instructions":"UR","counter":"VR","itemWrapper":"WR","flavorImg":"XR","left":"YR","quantityControl":"ZR","quantity":"aS","qtyButton":"bS","minus":"cS","plus":"eS"};
    if(module.hot) {
      // 1743628927929
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  